// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nuxt-link-exact-active[data-v-25fd23b7]{--text-opacity:1;color:#f39313;color:rgba(243,147,19,var(--text-opacity))}", ""]);
// Exports
module.exports = exports;
